import React from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";

export const MICROLAB_NAVY = "#03045E";

// Vector version of the official μLAB logo (src/assets/images/logos/microlab-logo.webp),
// drawn inline so it stays crisp at any size and the wordmark can switch colour in dark mode.
function MicrolabLogo({ height, textColor, markColor, glyphColor, sx, ...rest }) {
  return (
    <Box
      component="svg"
      viewBox="0 0 2000 788"
      role="img"
      aria-label="μLAB"
      sx={[{ height, width: "auto", display: "block", flexShrink: 0 }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...rest}
    >
      <rect width="788" height="788" rx="100" fill={markColor} />
      <g fill="none" stroke={glyphColor} strokeWidth="82" strokeLinecap="round" strokeLinejoin="round">
        <path d="M206 198V590" />
        <path d="M206 372C206 446 266 488 357 488C452 488 520 440 530 372" />
        <path d="M530 198V420C530 466 556 486 610 486" />
      </g>
      <g fill={textColor} fillRule="evenodd">
        <path d="M947 203H1025V522H1220V588H947Z" />
        <path d="M1388 200H1471L1626 588H1541L1507 500H1351L1320 588H1237ZM1376 435H1482L1428 290Z" />
        <path d="M1668 200H1830C1930 200 1975 250 1975 302C1975 344 1952 370 1920 382C1965 395 1995 432 1995 482C1995 542 1950 588 1860 588H1668ZM1746 265V354H1830C1875 354 1898 334 1898 310C1898 284 1875 265 1830 265ZM1746 420V522H1840C1890 522 1913 500 1913 471C1913 441 1890 420 1840 420Z" />
      </g>
    </Box>
  );
}

MicrolabLogo.defaultProps = {
  height: 28,
  textColor: MICROLAB_NAVY,
  markColor: MICROLAB_NAVY,
  glyphColor: "#ffffff",
  sx: {},
};

MicrolabLogo.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
  textColor: PropTypes.string,
  markColor: PropTypes.string,
  glyphColor: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};

export default MicrolabLogo;
